import React, { Component } from 'react';

class FeatureLeft extends Component {
    constructor(props){
        super(props);
        this.state = {
            collLeft: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    // Actualizado: "Licenciatura en Contaduría" → agrega institución y cédula (CV)
                    title: 'Licenciatura en Contaduría Pública — UAEH',
                    text: 'Formación en la Universidad Autónoma del Estado de Hidalgo. Cédula Profesional 2254994.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    // Actualizado: título genérico → agrega institución y fechas (CV)
                    title: 'Maestría en Ingeniería Económico-Financiera — La Salle Pachuca',
                    text: 'Estudios de posgrado en la Universidad La Salle Pachuca (2018–2020), enfocados en finanzas públicas y economía aplicada.'
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    // Actualizado: "Certificado" → agrega código EC0689 y año 2023 (CV)
                    title: 'Certificación EC0689 en Hacienda Pública Municipal',
                    text: 'Certificación emitida por CONOCER en 2023, acreditando competencias en la gestión de la hacienda pública municipal.'
                }
            ]
        }
    }

    render() {
        return (
            <div className="topic-items">
            {
                    this.state.collLeft.map((data,i) => (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>
                    ))
            }
            </div>
        );
    }
}

export default FeatureLeft;
